<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex flex-col bg-img items-center justify-center">
		<div class="vx-row">
			<h2 class="mb-8" style="color: #5c5c5c;">您的账号存在多个角色，请选择登录。</h2>
		</div>
		<div class="vx-row">
			<div v-if="roles.includes('admin')" :class="{'md:w-1/3': roles.length == 3}" class="vx-col w-full sm:w-1/2 mb-base cursor-pointer role-card"
					 @click="onClickSelectPermission('admin')">
				<statistics-card
					icon="UserIcon"
					color="primary"
					statistic=""
					statisticTitle="教管"
				></statistics-card>
			</div>
			<div v-if="roles.includes('teacher')" :class="{'md:w-1/3': roles.length == 3}" class="vx-col w-full sm:w-1/2 mb-base cursor-pointer role-card"
					 @click="onClickSelectPermission('teacher')">
				<statistics-card
					icon="UserIcon"
					color="success"
					statistic=""
					statisticTitle="教师"
				></statistics-card>
			</div>
			<div v-if="roles.includes('student')" :class="{'md:w-1/3': roles.length == 3}" class="vx-col w-full sm:w-1/2 mb-base cursor-pointer role-card"
					 @click="onClickSelectPermission('student')">
				<statistics-card
					icon="UserIcon"
					color="warning"
					statistic=""
					statisticTitle="学生"
				></statistics-card>
			</div>
		</div>
  </div>
</template>

<script>
import StatisticsCard from '@/components/statistics-cards/StatisticsCard.vue';
import { setEduRole } from '@/api/user'
export default {
  data() {
    return {
			roles: [],
		};
  },
  components: {
		StatisticsCard
	},
	mounted() {
		this.roles = this.$store.state.roles
		if (this.roles < 2) {
			this.$router.push('/')
		}
	},
  computed: {},
  methods: {
		onClickSelectPermission(role) {
			setEduRole({role: role}).then(res => {
				if (res.code == 1) {
					// 设置学校信息
					localStorage.setItem('eduRole', role);
					this.$store.dispatch('updateSchool', res.data.school_info);
					this.$acl.change(role)
					this.$store.dispatch('updateEduRole', role);
					this.$router.push('/');
				}
			})
		}
	},
};
</script>

<style lang="scss">
	.role-card {
		transition: 0.5s;
	}
	.role-card:hover {
		transform: translateY(-10px);
	}
</style>
